import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'
import {
  Bar,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import BoxTitle from 'components/atoms/BoxTitle'
import { HowToReg } from '@mui/icons-material'
import { useGET_benchmarkEvaluationStatsQuery } from 'redux/api/benchmarkEvaluationsApi'
import { removeEmpty } from 'utils/helpers'

const BenchmarkPerformanceChart: FC<any> = ({filters = {}}) => {
  const { t } = useTranslation()

  const { data: chart } = useGET_benchmarkEvaluationStatsQuery(removeEmpty(filters) as any)

  const data = chart ? chart.map(c => {
    let stack = {
      month: c.month,
      strength: 80,
      bridge: 50, 
      gap: 30,
      performance: c.avg_score
    }
    return stack
  }) : null
  
  return (
    <>{ chart && chart.length>0 && data &&
    <div style={{ display: 'flex', width: '100%' }}>
      <Box className="thick-border plop-performance-chart" sx={{ width: '100%' }}> 
        <BoxTitle title={ t('common.average-level-of-performance') } icon={<HowToReg />} />
        <Box sx={{ paddingBottom: '40px', height: '344px' }}>
          <ResponsiveContainer width='100%' height='115%'>
            <ComposedChart 
              data={data}
              margin={{
                top: 20,
                right: 0,
                bottom: 40
              }}
            >
              <XAxis dataKey='month' interval={0} tick={<CustomizedAxisTick />} />
              <YAxis type='number' domain={[0, 100]} />
              <Legend layout="horizontal" verticalAlign="top" align="right" />
              <Tooltip />
              <Bar
                hide={false}
                dataKey='performance'
                fill={"#b82aceff"}
                barSize={20}
                label={<CustomizedLabel />}
              /> 
              <Line
                type="linear"
                legendType='none' 
                hide={false}
                dataKey='strength'
                stroke={"#73d5a6"}
                strokeWidth={1}
                label={<CustomizedLabel />}
              /> 
              <Line
                type="linear"
                legendType='none' 
                hide={false}
                dataKey='bridge'
                stroke={"#ffd853"}
                strokeWidth={1}
                label={<CustomizedLabel />}
              /> 
              <Line
                type="linear"
                legendType='none' 
                hide={false}
                dataKey='gap'
                stroke={"red"}
                strokeWidth={1}
                label={<CustomizedLabel />}
              /> 


            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </Box>
      <div style={{ paddingLeft: '20px' }}>
        

      </div>
      </div> }
      </>
  )
}

export default BenchmarkPerformanceChart

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value} %`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}
